import { Component, OnInit } from '@angular/core';
import { CommonFunctionService ,UserPOSData} from "./../../../services/Common/common-function.service";
import { Validators, FormControl } from "@angular/forms";
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { EmployeeService } from '../../POSServices/Employees/employee.service';
const swal = require('sweetalert');
@Component({
  
  selector: 'app-employee',
  templateUrl: './employee.component.html',
  styleUrls: ['./employee.component.scss']
})
export class EmployeeComponent implements OnInit {
  Mobileerrormessage:any;
  mobileerrorvalidation:boolean=false;
  currency:any;
  mobileerror:boolean=false;
  date= new FormControl("", [Validators.required]);
  isReadytoUpdateEmployee : boolean = false;
  Emailerror:any
  merchantdata: UserPOSData ;
  isemailverify: boolean = false;
  isemployee:boolean = false;
  Email  = new FormControl("", []);
  Type = [
    { text: "Cashier", value: "Cashier" },
    { text: "Manager", value: "Manager" },
    { text: "Backend User", value: "Backend User" },
    { text: "Kitchen User", value: "Kitchen User" },
    { text: "Admin", value: "Admin" },

  ];
  rows;
  isNewEmployee: boolean = true;
  isUpdateEmployee: boolean = false;
  CustomerId = new FormControl("", [Validators.required]);
  FirstName = new FormControl("", [Validators.required, Validators.maxLength(20), Validators.minLength(1), Validators.pattern("^(?! )[a-zA-Zs ]*$")]);
LastName = new FormControl("", [Validators.required, Validators.maxLength(20), Validators.minLength(1), Validators.pattern("^(?! )[a-zA-Zs ]*$")]);
EmployeeId= new FormControl("", [Validators.required]);
  PassCode=new FormControl("", [Validators.required]);
  

  //Email= new FormControl("", []);
  PhoneNo= new FormControl("", [Validators.required, Validators.max(9999999999), Validators.min(1000000000), Validators.pattern("^(?! )[0-9]+?$")]);
  // PhoneNo= new FormControl("", [Validators.required]);
  Address= new FormControl("", [Validators.required]);
  Role=  new FormControl("", [Validators.required, Validators.maxLength(20), Validators.minLength(1), Validators.pattern("^(?! )[a-zA-Zs ]*$")]);
 // PassCode= new FormControl("", [Validators.required, Validators.pattern("^(?!000000)[0-9]{4}$")]);
  Manager= new FormControl("", [Validators.required]);
  NickName= new FormControl("", []);
  id= new FormControl("", [Validators.required]);
  DateTime;
  constructor(
    private service: EmployeeService,
    private commonfunction: CommonFunctionService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.merchantdata = this.commonfunction.getUserPOSData();
    this.getGetEmployeeDetails();
    this.currency = this.commonfunction.GetCurrencysymbol();
  }
  EmailVerfication()
  {
    let form = { merchantKeyId: "", id:"", PosSubscriptionId:"" };
    this.activatedRoute.params.subscribe(params => {
      console.log(params["id"]);
      console.log(params["merchantKeyId"]);
      // form.id = params["id"];
  
      form.id = this.Email.value;
      form.merchantKeyId = params["merchantKeyId"];
      form.PosSubscriptionId  = this.merchantdata.PosSubscriptionId;
      console.log("formdata---" + form);
    });   

  }
  onChange()
  {
    let form = { merchantKeyId: "", id:"", PosSubscriptionId:"" };
    this.activatedRoute.params.subscribe(params => {
      console.log(params["id"]);
      console.log(params["merchantKeyId"]);
      // form.id = params["id"];
  
      form.id = this.EmployeeId.value;
      form.merchantKeyId = params["merchantKeyId"];
      form.PosSubscriptionId  = this.merchantdata.PosSubscriptionId;
      console.log("formdata---" + form);
    });   

    this.service.GetEmployeeIDDetail(form).subscribe(result => {   
      // console.log("result.Id---" + result);
      if(result==null)
      {
        this.isemployee=false;
      }
      else{
        this.isemployee=true;
      //  var eid=this.employeeId.value;
      //  var rid=result.employeeId
      //  if(eid==rid)
      //  {
      //       this.isemployee=true;
      //  }
      
      }
    });
 
  }

  getGetEmployeeDetails() {
    let form = { merchantKeyId: "", id: "", PosSubscriptionId:"" };
    this.activatedRoute.params.subscribe(params => {
      console.log(params["id"]);
      console.log(params["merchantKeyId"]);
      form.id = params["id"];
      form.merchantKeyId = params["merchantKeyId"];
      form.PosSubscriptionId  = this.merchantdata.PosSubscriptionId;
      console.log("formdata---" + form);
    });   

    this.service.GetEmployeeDetail(form).subscribe(result => {   
      console.log("result.Id---" + result);
      if (result.Id > 0) {
        this.isUpdateEmployee = true;
        this.isNewEmployee = false;
        this.rows = result;
      } else {
        this.isUpdateEmployee = false;
        this.isNewEmployee = true;
      }
    });
 
  }


  onChangemobile()
  {
    this.mobileerrorvalidation=true;
    this.mobileerrorvalidation = this.commonfunction.Mobilenumbervalidation(this.PhoneNo.value);
    if(this.mobileerrorvalidation==false)
    {
       this.mobileerrorvalidation=false;
      this.Mobileerrormessage="";
    let form = { merchantKeyId: "", Email:"", PosSubscriptionId:"" ,MobileNumber:""};
    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    this.activatedRoute.params.subscribe(params => {
      console.log(params["id"]);
      console.log(params["merchantKeyId"]);
      form.Email = this.Email.value;
      form.MobileNumber=this.PhoneNo.value;
      if(form.MobileNumber=="")
      {
        form.MobileNumber="undefined";
      }
      if(form.Email=="")
      {
        form.Email="undefined";
      }
      form.merchantKeyId = params["merchantKeyId"];   
      form.PosSubscriptionId  =merchantdata.PosSubscriptionId;
      console.log("formdata---" + form);
    });   
    this.service.GetEmployeeMobiledetails(form).subscribe(result => {   
      if(result!=null)
      {
      
     if(this.PhoneNo.value == result.phoneNo)
       {
        this.mobileerror=true;

       }
       else{
        this.mobileerror=false;
       }
      }
      else{
        this.mobileerror=false;
       }
     
    });
  }
  else
  {
    this.Mobileerrormessage="Enter valid Mobile Number";
  }
  }




  onChangeid()
  {
    let form = { merchantKeyId: "", Email:"", PosSubscriptionId:"" ,MobileNumber:""};
    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    this.activatedRoute.params.subscribe(params => {
      console.log(params["id"]);
      console.log(params["merchantKeyId"]);
      form.Email = this.Email.value;
      form.MobileNumber=this.PhoneNo.value;
      if(form.MobileNumber=="")
      {
        form.MobileNumber="undefined";
      }
      if(form.Email=="")
      {
        form.Email="undefined";
      }
      form.merchantKeyId = params["merchantKeyId"];   
      form.PosSubscriptionId  =merchantdata.PosSubscriptionId;
      console.log("formdata---" + form);
    });   
    this.service.GetEmployeeEmaildetails(form).subscribe(result => {   
      if(result!=null)
      {
       if(this.Email.value == result.email)
       {
         this.Emailerror=true;
       }
       else{
        this.Emailerror=false;
       }
      }
      else{
        this.Emailerror=false;
       }
     
    });
  }














  newEmployee() {
    let form = {
      PosSubscriptionId: "",
    EmployeeId : "",
    FirstName : "",
    LastName : "",
    CustomId : "",
    PassCode : "",
    Email : "",
    NickName : "",
    Role : "",
    ManagerId : "",
    IpAddress : "",
    Device : "",
    UpdateduserId : "" ,
    Address:"",
    PhoneNo:""
   
    };
    form.PhoneNo =this.PhoneNo.value;
    form.NickName = this.NickName.value;
    form.EmployeeId = this.EmployeeId.value;
    form.FirstName = this.FirstName.value;
    form.LastName = this.LastName.value;
    form.PassCode = this.PassCode.value;
    form.Email = this.Email.value;
    form.Role = this.Role.value;
    form.Address=this.Address.value;
    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    form.PosSubscriptionId = merchantdata.PosSubscriptionId;
    // alert(this.requestDate.value);
    // alert(this.dueDate.value);
    this.service.AddEmployee(form).subscribe(result => {
      console.log(" result - ", result);
      if (result.responseText == null) { 
           localStorage.removeItem('employeelist');
        swal("Added", "Employee Added Successfully", "success"); 
        this.router.navigate(["/pos/employee/manage"]);
      }
      else
      {
        swal("Duplicate",result.responseText, "warning");  
      }
    });
  }



  updateEmployee()
  {
    let form = {
        PosSubscriptionId: "",
    EmployeeId : "",
    FirstName : "",
    LastName : "",
    CustomId : "",
    PassCode : "",
    Email : "",
    NickName : "",
    Role : "",
    ManagerId : "",
    IpAddress : "",
    Device : "",
    UpdateduserId : ""    ,
    Id:"",
    Address:"",
    PhoneNo:"",
    DateTime:"",
    };
    form.PhoneNo = this.PhoneNo.value;
    // form.DateTime =  this.DateTime.value;
    form.NickName = this.NickName.value;
    form.EmployeeId = this.EmployeeId.value;
    form.FirstName = this.FirstName.value;
    form.LastName = this.LastName.value;
    form.PassCode = this.PassCode.value;
    form.Email = this.Email.value;
    form.Role = this.Role.value;
    form.Address=this.Address.value;
    form.Id=this.id.value;
    form.DateTime=this.date.value;
    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    form.PosSubscriptionId = merchantdata.PosSubscriptionId;
    // alert(this.requestDate.value);
    // alert(this.dueDate.value);
    this.service.UpdateEmployee(form).subscribe(result => {
      console.log(" result - ", result);
      if (result.responseText == null) { 
        localStorage.removeItem('employeelist');
     swal("Added", "Employee Added Successfully", "success"); 
     this.router.navigate(["/pos/employee/manage"]);
   }
   else
   {
     swal("Duplicate",result.responseText, "warning");  
   }
    });
  }

  firstNameError() {
    return this.FirstName.hasError("required") ? "First Name is required"
      : this.FirstName.hasError("pattern") ? "First Name should be alphabets only" : "";
  }

  employeeIdIderrors() {
    return this.EmployeeId.hasError("required") ? "Employee Id is required"
      : this.EmployeeId.hasError("pattern") ? "First Name should be allow only alphabets" : "";
  }

  lastNameError() {
    return this.LastName.hasError("required") ? "Last Name is required"
      : this.LastName.hasError("pattern") ? "Last Name should be alphabets only" : "";
  }

  addresserrors() {
    return this.Address.hasError("required") ? "First Name is required"
      : this.Address.hasError("pattern") ? "First Name should be allow only alphabets" : "";
  }

  Emailerrors() {
    return this.Email.hasError("pattern") ? "Please enter email address in correct Format" : "";
  }

  PhoneNoerrors() {
    return this.PhoneNo.hasError("required") ? "Phone Number  is required"
      : this.PhoneNo.hasError("pattern") ? "Phone Number should be numeric" : "";
  }

  passCodeerrors()
  {
    return this.PassCode.hasError("required") ? "PassCode  is required"
    : this.PassCode.hasError("pattern")
    ? "Please Enter valid passCode which Must be 4 digit number only"
       : "";
  }

  
  roleerrors()
  {
    return this.Role.hasError("required") ? "Role Name is required"
      : "";
  }
  
  managererrors()
  {
    return this.Manager.hasError("required") ? "First Name is required"
      : this.Manager.hasError("pattern") ? "First Name should be allow only alphabets" : "";
  }
  onKey()
  {
    this.isReadytoUpdateEmployee = true;

  }

}
